import { useEffect, useRef } from 'react'

const CHECK_INTERVAL = 60_000 // 1 minuto

export default function useVersionCheck() {
  const currentVersion = useRef<string | null>(null)
  const deferReload = useRef(false)

  useEffect(() => {
    if (import.meta.env.DEV) return

    function isUserTyping() {
      const el = document.activeElement
      return el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || (el as HTMLElement)?.isContentEditable
    }

    async function checkVersion() {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' })
        if (!res.ok) return
        const { version: serverVersion } = await res.json()

        if (!currentVersion.current) {
          currentVersion.current = serverVersion
          return
        }

        if (serverVersion !== currentVersion.current) {
          console.log('[Comunidade] Nova versão detectada, atualizando...')

          // Notifica o Flutter (se embedado em WebView)
          notifyFlutter('version_update', { oldVersion: currentVersion.current, newVersion: serverVersion })

          if (isUserTyping()) {
            deferReload.current = true
          } else {
            window.location.reload()
          }
        }
      } catch {
        // Silencioso
      }
    }

    function onFocusOut() {
      if (deferReload.current) {
        window.location.reload()
      }
    }

    // Escuta comando do Flutter pra forçar reload
    window.addEventListener('message', (e) => {
      if (e.data === 'flutter_force_reload') {
        window.location.reload()
      }
    })

    checkVersion()
    const interval = setInterval(checkVersion, CHECK_INTERVAL)
    document.addEventListener('focusout', onFocusOut)

    return () => {
      clearInterval(interval)
      document.removeEventListener('focusout', onFocusOut)
    }
  }, [])
}

/**
 * Envia mensagem pro Flutter via JavaScript Bridge.
 * O Flutter escuta com `JavaScriptChannel` no WebView.
 *
 * No Flutter:
 *   WebView(
 *     javascriptChannels: {
 *       JavaScriptChannel(name: 'CommunityBridge', onMessageReceived: (msg) {
 *         final data = jsonDecode(msg.message);
 *         if (data['type'] == 'version_update') {
 *           // Limpar cache do WebView e recarregar
 *           controller.clearCache();
 *           controller.reload();
 *         }
 *       }),
 *     },
 *   )
 */
function notifyFlutter(type: string, data?: Record<string, unknown>) {
  try {
    // @ts-ignore — CommunityBridge é injetado pelo Flutter
    if (window.SispoliBridge) {
      // @ts-ignore
      window.SispoliBridge.postMessage(JSON.stringify({ type, ...data }))
    }
  } catch {
    // Não está no Flutter — ignora
  }
}
